import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import jobWorkService from '../services/job-work.service';
import { setMessage } from './message';

export const fetchjobWorkList = createAsyncThunk(
    'diesize/fetchjobWorkList',
    async thunkAPI => {
        try {
            const response = await jobWorkService.getJobWork();
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const createjobWorkList = createAsyncThunk(
    'diesize/createjobWorkList',
    async (workorderId, thunkAPI) => {
        try {
            const response = await jobWorkService.createJobWork(workorderId);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

const initialState = {
    jobWorkdata: [], // Ensure the data is always an empty array initially
    loading: false,
    status: 'idle',
    error: null,
};

const jobWorkSlice = createSlice({
    name: 'jobWork',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetJobWorkList: state => {
            state.jobWorkdata = []; // This will clear the list
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchjobWorkList.pending, state => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(fetchjobWorkList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                //const fetchedPage = action.payload.page || state.currentPage;
                state.jobWorkdata = action.payload.results.data || [];
                state.totaldie = action?.payload?.results?.total_die_count || 0;
                state.loading = false;
            })
            .addCase(fetchjobWorkList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(createjobWorkList.pending, state => {
                state.status = 'loading';
            })
            .addCase(createjobWorkList.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createjobWorkList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { setLoading, resetJobWorkList } = jobWorkSlice.actions;
const { reducer } = jobWorkSlice;
export default reducer;